import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Scissors } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const TrimRegion = ({ region, country, total, announce, onDone }) => {
  const [busy, setBusy] = useState(false);
  if (!region) return null;
  const run = async () => {
    const n = parseInt(window.prompt(`Keep how many ${region} towns? Towns with a guide, a status or notes are always kept.`, "50"), 10);
    if (!n || n < 1) return;
    if (n >= total) return toast.info(`${region} already has ${total} towns or fewer`);
    setBusy(true);
    try {
      const { data: p } = await api.post("/towns/trim-preview", { region, country: country || "Italy", keep: n });
      if (!p.remove.length) return toast.info("Nothing to remove");
      const sample = p.remove.slice(0, 12).map((t) => t.town).join(", ");
      if (!window.confirm(`Keep ${p.keep.length} of ${p.total} ${region} towns (${p.protected} protected) and remove ${p.remove.length}?\n\nRemoving: ${sample}${p.remove.length > 12 ? ", …" : ""}\n\nYou can undo for 30 minutes.`)) return;
      const { data: d } = await api.post("/towns/delete", { ids: p.remove.map((t) => t.id) });
      announce(d.batch_id, `${d.deleted} ${region} towns`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={run} disabled={busy} className="rounded-none" data-testid="towns-trim-region">
      {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Scissors className="w-4 h-4 mr-2" />}{busy ? "Ranking towns…" : `Keep the best of ${region}`}
    </Button>
  );
};
